// extracted by css-extract-rspack-plugin
export default {"size480":"480px","size1280":"1280px","spaceSmall":"12px","spaceMedium":"20px","section":"ai-team-section__section___zwdsr","cards":"ai-team-section__cards___SuVNL"};